import React, { useContext } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";
import { CheckIcon } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/CheckIcon";

import { UserDetails } from "appContext";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { LastUpdatedDetails } from "../../employeeManagement/userProfile/helper";

const PsidMappingSuccessDialog = ({ open, onClose, vendorData }) => {
  const userDetails = useContext(UserDetails);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          maxWidth: "550px",
          width: "100%",
          m: "auto",
          boxShadow: "0px 8px 32px rgba(0, 70, 98, 0.18)",
          p: 0,
        },
      }}
    >
      {/* <DialogTitle
        style={{
          backgroundColor: "#f8f9fa",
          borderBottom: "1px solid #e9ecef",
          padding: "24px",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" style={{ fontWeight: 600, margin: 0 }}>
          PSID Mapping Successful
        </Typography>
      </DialogTitle> */}

      <DialogContent
        sx={{
          p: "32px 32px 16px 32px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Success Message */}
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Box
            sx={{
              background: "#E6F4EA",
              borderRadius: "50%",
              width: 64,
              height: 64,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <CheckIcon color="#28a745" style={{ fontSize: 36 }} />
          </Box>
          <Typography
            variant="h6"
            sx={{
              color: "#004662",
              fontWeight: 700,
              fontSize: "20px",
              mb: 1,
            }}
          >
            PSID Mapping Successful
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "#757575", fontSize: "15px", mb: 1 }}
          >
            Students mapped with vendor ID <b>{vendorData?.vendorSapCode}</b>
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "#757575", fontSize: "14px", mb: 0 }}
          >
            All relevant users at the respective branches have been notified to
            initiate the payment request
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 4,
          py: 2,
          borderTop: "1px solid #E0E0E0",
          backgroundColor: "#F8F9FA",
          justifyContent: "center",
        }}
      >
        <AButton
          onClick={onClose}
          variant="primary_filled"
          sx={{ minWidth: "120px", fontWeight: 600, fontSize: "16px" }}
        >
          OK
        </AButton>
      </DialogActions>

      <Box sx={{ textAlign: "center", py: 1 }}>
        <Typography sx={{ color: "#AFAFAF", fontSize: "12px" }}>
          Created by{" "}
          <b>
            {userDetails?.employeeId} ({userDetails?.firstName})
          </b>{" "}
          on {LastUpdatedDetails(new Date())}
        </Typography>
      </Box>
    </Dialog>
  );
};

export default PsidMappingSuccessDialog;
